export default __webpack_public_path__ + "locales/en/Ldap.json?hash=2d2d8a4fd071953edb10769c6f5e1a1a";